<template>
  <div class="healthcard">
      <div class="header" style="">
      <div class="photo">
        <img v-if="profile_picture != null" :src="profile_picture"/>
        <span v-else class="initial">{{data.customer.name[0]}}
        </span>
        <!-- <font-awesome-icon class="edit" :icon="['fa','pen-square']"></font-awesome-icon> -->
        <img src="@/assets/images/edit-round-prm.png" class="edit" @click="openEditModal(true, 4)" />
      </div>
      <div class="info">
        <div class="details">
          <span class="label">Nome</span>
          <span class="value">{{data.customer.name}}</span>
        </div>
        <div class="details-container">
          <div @click="printFile()" class="circle">
          </div>
          <div class="details">
            <div class="box">
              <span class="label">Nascimento</span>
              <span class="value">{{birth_date}}</span>
            </div>
            <div class="box">
              <span class="label">Sexo biológico</span>
              <span class="value">{{data.customer.gender === 'M' ? 'Masculino' : 'Feminino'}}</span>
            </div>
            <div class="box">
              <span class="label">Etnia</span>
              <span class="value">{{getEthnicity()}}</span>
            </div>
          </div>
          <div class="details">
            <div class="box">
              <span class="label">Cpf</span>
              <span class="value">{{data.customer.cpf}}</span>
            </div>
            <div class="box">
              <span class="label">Altura</span>
              <span class="value">{{ this.imc && this.imc['heigth'] ? this.imc['heigth'] : '--'}}</span>
            </div>
            <div class="box">
              <span class="label">Peso</span>
              <span class="value">{{ this.imc && this.imc['weigth'] ? this.imc['weigth'] : '--'}}</span>
            </div>
          </div>
          <div class="details">
            <div class="box">
              <span class="label">Imc</span>
              <span class="value">{{ this.imc && this.imc['calc'] ? this.imc['calc'].toFixed(2) : '--'}}</span>
            </div>
            <div class="box">
              <span class="label">Fumante</span>
              <span class="value">{{ this.answers.fumante ? this.answers.fumante : '--' }}</span>
            </div>
            <div class="box">
              <span class="label">Pressão(sistólica e diastólica)</span>
              <span class="value"> {{ this.answers.sistolica }} / {{ this.answers.diastolica }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="flex-container">
        <div class="grid-container">
          <div class="details">
            <div class="box">
              <span class="label">Alergias Informadas
                <font-awesome-icon class="edit" :icon="['fa','edit']" @click="openEditModal(true, 0)" />
              </span>
              <span v-if="customer.health_information && customer.health_information.allergies && customer.health_information.allergies.length > 0">
                  <span class="value" v-bind:key="x" v-for="(allergy, x) in customer.health_information.allergies">
                  <div class="dot primary" /> {{allergy}}</span>
              </span>
              <span class="value" v-else> Não informado</span>
            </div>
            <div class="box">
              <span class="label">Doenças Informadas</span>
              <span v-if="informedDiseases.length > 0">
                <span class="value" v-bind:key="x" v-for="(disease, x) in informedDiseases">
                  <div class="dot primary" /> {{disease}}
                </span>
              </span> 
              <span v-else class="value"> Não informado</span>
            </div>
          </div>

          <div class="details">
            <div class="box">
              <span class="label">Contato de emergência
                <font-awesome-icon class="edit" :icon="['fa','edit']" @click="openEditModal(true, 2)" />
              </span>
              <span class="value" v-if="!!customer.emergency_contact && !!customer.emergency_contact.name">{{customer.emergency_contact.name}}</span>
              <span class="value" v-if="!!customer.emergency_contact && !!customer.emergency_contact.phone">{{customer.emergency_contact.phone}}</span>
              <span class="value" v-else>Não informado</span>
            </div>
            <div class="box">
              <span class="label">Plano de saúde</span>
              <span v-if="!!this.answers.health_insurance" class="value">{{this.answers.health_insurance}}</span>
              <span v-else class="value">Não informado</span>
            </div>
          </div>
          <div class="details">
            <div class="box">
            <span class="label">Tipo sanguíneo
                  <font-awesome-icon class="edit" :icon="['fa','edit']" @click="openEditModal(true, 1)" />
                </span>
                <span class="value"
                      v-if="customer.health_information && customer.health_information.blood_type != null && customer.health_information.blood_type != ''">
                      <div class="blood"><font-awesome-icon :icon="['fa', 'tint']"/> </div> {{customer.health_information.blood_type}}
                    </span>
                <span class="value" v-else> Não informado</span>
            </div>
            <div class="box">
            <span class="label">Vacina Covid
              </span>
                <span v-if="!!this.answers.vaccine" class="value">
                  {{ this.answers.vaccine }}
                </span>
                <span v-else class="value">
                  Não informado
                </span>
          </div>
        </div>
        </div>

        <div class="line" v-if="diagnostics.length > 0 || risks.length > 0 || factors.length > 0"/>

        <div v-if="diagnostics.length > 0 || risks.length > 0 || factors.length > 0" class="grid-container">
          <div class="details">
            <div class="box">
              <span class="label">Riscos <div class="dot-container"><div class="dot"></div> <div class="dot green"></div> <div
                class="dot yellow"></div> <div class="dot red"></div></div></span>
              <span v-if="risks && risks.length > 0">
                    <div class="risk" v-bind:key="x" v-for="(risk, x) in risks">
                      <span class="value">
                        <div class="dot green" v-if="risk.level === 'low'"></div>
                        <div class="dot yellow" v-if="risk.level === 'medium'"></div>
                        <div class="dot red" v-if="risk.level === 'high'"></div>
                        {{risk.label}}
                      </span>
                      <span class="date">
                        última aferição {{getDate(risk.date)}}
                      </span>
                    </div>
                  </span>
              <span class="value" v-else> Não informado</span>
            </div>
          </div>


          <div class="details">
            <div class="box">
              <span class="label">Diagnósticos Preliminares<div class="dot-container"><div class="dot"></div> <div style="margin-right:7px" class="dot green"></div><div style="margin-right:7px" class="dot red"></div></div></span>
              <span v-if="diagnostics && diagnostics.length > 0">
                    <div class="risk" v-bind:key="x" v-for="(diagnostic, x) in diagnostics">
                      <span class="value">
                        <div class="dot green" v-if="diagnostic.level === 'low'"></div>
                        <div class="dot yellow" v-if="diagnostic.level === 'medium'"></div>
                        <div class="dot red" v-if="diagnostic.level === 'high'"></div>
                        {{diagnostic.label}} 
                      </span>
                      <span class="date">
                        última aferição {{getDate(diagnostic.date)}}
                      </span>
                    </div>
                  </span>
              <span class="value" v-else> Não informado</span>
            </div>
          </div>

          <div class="details">
            <div class="box">
              <span class="label">Fatores Preliminares<div class="dot-container"><div class="dot"></div> <div style="margin-right:7px" class="dot green"></div><div style="margin-right:7px" class="dot yellow"></div><div style="margin-right:7px" 
              class="dot red"></div></div> </span>
              <span v-if="factors && factors.length > 0">
                    <div class="risk" v-bind:key="x" v-for="(factor, x) in factors">
                      <span class="value">
                        <div class="dot green" v-if="factor.level === 'low'"></div>
                        <div class="dot yellow" v-if="factor.level === 'medium'"></div>
                        <div class="dot red" v-if="factor.level === 'high'"></div>
                        {{factor.label}}
                      </span>
                      <span class="date">
                        última aferição {{getDate(factor.date)}}
                      </span>
                    </div>
                  </span>
              <span class="value" v-else> Não informado</span>
            </div>
          </div>
          
          </div>
          
                <!-- <div class="share">
          <span>compartilhar</span>
          <div class="qrcode">
            <img class="">
          </div>
                </div> -->
        </div>
      </div>
    <div class="footer">
      <div class="logo">
        <img src="@/assets/images/new_logo_horizontal.png"/>
      </div>
    </div>
    <edit-modal :field="modalField" :values="customer" @close="openEditModal(false, 0)" @updateCustomer="updateCustomer"
                v-if="modal"/>
    <loading-screen v-if="loadingScreen"/>
  </div>
</template>

<script>
    import {GET_CUSTOMER_ANSWERS, GET_HEALTHID_DIGITAL, GET_PROFILE_PICTURE, GET_CUSTOMER_RISKS} from '../../services/customer';

    import EditModal from './EditModal.vue'

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEdit, faTint, faPenSquare} from '@fortawesome/free-solid-svg-icons';

    library.add(faEdit);
    library.add(faTint);
    library.add(faPenSquare);

    export default {
        props: ['data'],
        name: "card-health-id",
        components: {EditModal},
        data() {
            return {
                loadingScreen: false,
                modalField: 0,
                modal: false,
                customer: {},
                answers: [],
                risks: [],
                diagnostics: [],
                factors: [],
                informedDiseases: [],
                profile_picture: null,
                remote_picture: null,
                birth_date: '',
                imc: null,
                last_kit_id: null,
            }
        },
        methods: {
            openEditModal(open, field) {
                this.modalField = field;
                this.modal = open;
            },
            async getProfilePhoto() {
                this.remote_picture = await GET_PROFILE_PICTURE();
                if (this.remote_picture != null) {
                    this.profile_picture = this.remote_picture;
                }
            },
            getDate(date) {
                let newDate = new Date(date);
                newDate = newDate.getDate() + '/' + (this.aditionalZero(newDate.getMonth() + 1)) + '/' + newDate.getFullYear();
                return newDate;
            },
            getBirthdate() {
                let date = new Date(this.customer.birth_date);
                date = (this.aditionalZero(date.getDate())) + '/' + (this.aditionalZero(date.getMonth() + 1)) + '/' + date.getFullYear();
                this.birth_date = date;
            },
            aditionalZero(number) {
                if (number <= 9)
                    return "0" + number;
                else
                    return number;
            },
            getEthnicity() {
                let ethnicity = '';
                switch (this.customer.ethnicity) {
                    case 'A':
                        ethnicity = 'Amarelo';
                        break;
                    case 'B':
                        ethnicity = 'Branco';
                        break;
                    case 'I':
                        ethnicity = 'Indígena';
                        break;
                    case 'M':
                        ethnicity = 'Mestiço';
                        break;
                    case 'N':
                        ethnicity = 'Negro';
                        break;
                    case 'P':
                        ethnicity = 'Pardo';
                        break;
                    default:
                        ethnicity = 'Amarelo';
                        break;
                }
                return ethnicity;
            },

            async getMetrics(){
              const data = await GET_CUSTOMER_RISKS();
              data.map((item) => {
                let item_label = item.label + ' ' + item.risk_name.replace('Risco', ' ');
                item_label = item_label.replace('detectado', 'detectado - ');
                let item_level;
                switch(item.label){
                  case 'Alto':
                    item_level = 'high';
                    break;
                  case 'Médio':
                  case 'Médio alto':
                    item_level = 'medium';
                    break;
                  case 'Baixo':
                  case 'Médio baixo':
                    item_level = 'low';
                    break;
                  case 'Não detectado':
                    item_level = 'low';
                    break;
                  case 'Detectado':
                    item_level = 'high';
                    break;
                  default:
                    item_level = 'undefined';
                    break;
                }
                if(item.risk_name.startsWith('Risco de desenvolver') || item.risk_name.startsWith('Risco de sofrer') || item.risk_name.startsWith('Risco de Lesão')){
                  let name = 'Fatores Preliminares para Desenvolver ' + item.risk_name.replace('Risco de desenvolver', '').replace('Risco de sofrer', '').replace('Risco de', '') + ' - ' + item.label;
                  this.factors.push({label: name, level: item_level, date: item.metrification_date});
                } else if(item.risk_name.startsWith("Diagnóstico Preliminar") || item.risk_name.startsWith("Diagnostico Preliminar")){
                  this.diagnostics.push({label: item_label , level: item_level, date: item.metrification_date});
                } else{
                  this.risks.push({label: 'Risco ' + item_label, level: item_level, date: item.metrification_date});
                }
              })
            },

            async getAnswers(){
              const data = await GET_CUSTOMER_ANSWERS();
              this.responseAnswers = data.answers;
              this.responseResult = data.last_result;
              data.answers.imc ? this.answers.imc = data.answers.imc : '--';
              data.answers['Você fuma?'] ? this.answers.fumante = data.answers['Você fuma?'] : '--';
              data.answers['Sistólica (alta):'] ? this.answers.sistolica = data.answers['Sistólica (alta):'] : '--';
              data.answers['Diastolica (baixa):'] ? this.answers.diastolica = data.answers['Diastolica (baixa):'] : '--';
              data.answers['Diastólica (baixa):'] ? this.answers.diastolica = data.answers['Diastólica (baixa):'] : '--';
              data.answers['Já tomou a vacina?'] ? this.answers.vaccine = data.answers['Já tomou a vacina?'] : 'Não informado';
              data.answers['Você possui plano de saúde?'] ? this.answers.health_plan = data.answers['Qual?'] : 'Não informado';
              data.answers['Você é portador de alguma doença do coração?'] == 'Sim' ? this.informedDiseases.push('Doença do coração'): null;
              data.answers['Você é portador de Diabetes?'] == 'Sim' ? this.informedDiseases.push('Diabetes'): null;
              data.answers['Você é portador de Hipertensão?'] == 'Sim' ? this.informedDiseases.push('Hipertensão'): false;
              data.answers['Você é portador de quais doenças ou condições abaixo?'].includes('avc') ? this.informedDiseases.push('Avc'): false;
              data.answers['Você é portador de quais doenças ou condições abaixo?'].includes('dislipidemia') ? this.informedDiseases.push('Dislipidemia'): false;
              data.answers['Você é portador de quais doenças ou condições abaixo?'].includes('Osteoporose') ? this.informedDiseases.push('Osteoporose'): false;
              this.answers.imc ? this.imc = JSON.parse(this.answers.imc) : null;
            },

            updateCustomer(newCustomer) {
              
                this.customer = newCustomer;
                this.getProfilePhoto();
                this.$forceUpdate();
            },
            async printFile() {
                try {
                    this.loadingScreen = true;
                    const data = await GET_HEALTHID_DIGITAL();
                    if (data.url)
                        window.open(data.url);

                } catch (error) {
                    console.log(error);
                } finally {
                    this.loadingScreen = false;
                }
            }
        },
        mounted() {
            this.customer = this.data.customer;
        
            this.getAnswers().then(
              r => {
                this.getMetrics()
              }
            );
            this.getProfilePhoto();
            this.getBirthdate();
        }
    }
</script>

<style scoped>
  @import "./card-health-id.scss";
  @import "./responsive.css";

  @media screen and (max-width: 690px) {
    .card {
      padding: 1rem;
    }

    .healthcard {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CardHealthId/CardHealthId.vue